<template>
  <div class="inner-box">
    <div slot="content">
      <el-form size="medium" >
        <div class="content-name">
          <h2 class="dp-ib">{{ routeName }}</h2>
          <el-form-item label-width="0px" style="float: right;">
            <el-button type="primary" icon="el-icon-search" @click="goOpen">
              {{ this.$i18n.messages[this.$store.state.locale].search }}
            </el-button>
          </el-form-item>
        </div>
      </el-form>

      <div class="search-form">
        <el-form size="mini" style="margin-left: -45px;">
          <el-row style="margin-bottom: 0px;">
            <el-col :span="6">
              <el-form-item label="제조사" label-width="120px">
                <el-select v-model="form.maker" >
                  <el-option value='' label="전체">전체</el-option>
                  <el-option
                      v-for="item in combos['maker']"
                      :key="item.value"
                      :value="item.key"
                      :label="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="7">
              <el-form-item label="제품군" label-width="80px">
                <el-col :span="12">
                  <el-select v-model="form.modelGroup" @change="onModelGroupChange">
                    <el-option value='' label="전체">전체</el-option>
                    <el-option
                        v-for="item in combos['modelGroup']"
                        :key="item.key"
                        :value="item.key"
                        :label="item.value">
                    </el-option>
                  </el-select>
                </el-col>
                <el-col :span="12">
                  <el-select v-model="form.subModelGroup" v-show="changeModelGroupShow">
                    <el-option value='' label="전체">전체</el-option>
                    <el-option
                        v-for="item in combos['subModelGroup']"
                        :key="item.key"
                        :value="item.key"
                        :label="item.value">
                    </el-option>
                  </el-select>
                </el-col>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="대표모델" label-width="90px">
                <el-input type="text" v-model="form.standardModelNm" @keyup.native.enter="goOpen"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="모델" label-width="60px">
                <el-input type="text" v-model="form.modelNm" @keyup.native.enter="goOpen"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>

    <div class="table-area">
      <div class="table-b">
        <div class="table-header">
          <div class="grid-tbl-box">
            <ag-grid-vue
                ref="grid"
                :style="gridStyle"
                class="ag-theme-alpine"
                :column-defs="columnDefs"
                :grid-options="mainGridOptions"
                :row-data="data"
                :default-col-def="defaultColDef"
                :framework-components="frameworkComponent"
                :statusBar="statusBar"
                :enableRangeSelection="true"
                @grid-ready="onReadyMain" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DatepickerCellRenderer from "@/components/agGrid/datepicker-cell-renderer";
import MaskEditCellRenderer from "@/components/agGrid/maskedit-cell-renderer";
import SelectCellRenderer from "@/components/agGrid/select-cell-renderer";
import CheckboxCellRenderer from "@/components/agGrid/checkbox-cell-renderer";
import RadioCellRenderer from "@/components/agGrid/radio-cell-renderer";
import NumberInputCellRender from "@/components/agGrid/numberinput-cell-renderer";
import InputCellRender from "@/components/agGrid/input-cell-renderer";
import ButtonCellRenderer from "@/components/agGrid/button-cell-renderer";
import ReceptionModal_01 from "@/components/AS/History/Modal/ReceptionModal_01";

function _url(...args) {
  args = args.map(x =>
      String(x || "")
          .trim()
          .replace(/^\/*|\/*$/g, "")
  );
  return args.filter(x => x).join("/");
}

export default {
  props: {
  },
  data() {
    return {
      data: [],
      form: {
        companyId : '',
        maker : '',              // 제조사
        modelGroup : '',          // 제품군
        subModelGroup : '',
        standardModelNm : '',    //대표모델
        modelNm : '',            //모델명
        catId : '',
        sortType : '',
        page : 1,
        totalPage : 99999,
        curPage : 0,
        totalCount : 99999,
        processTime : ''
      },
      combos: {
        'maker' : [],         //제조사
        'modelGroup' : [],     //제품군
        'subModelGroup' : [],     //sub제품군
      },
      // AG-GRID OPTION [START]
      gridStyle : 'padding-top: 20px; width: 100%;height: 700px; min-height:100px;',
      defaultColDef: {
          resizable: true
        , filter:true
        , sortable: true
      },
      mainGridApi: null,
      mainColumnApi: null,
      mainGridOptions: {
        enableColResize: true,
        enableFilter: true,
        animateRows: false,
        enableSorting: true,
      },
      columnDefs: [],
      frameworkComponent : {
        datePicker: DatepickerCellRenderer,
        maskEdit: MaskEditCellRenderer,
        select: SelectCellRenderer,
        checkBox: CheckboxCellRenderer,
        radio: RadioCellRenderer,
        numberInput: NumberInputCellRender,
        input: InputCellRender,
        button: ButtonCellRenderer
      },
      statusBar: null,
      changeModelGroupShow : false,
    }
  },
  methods: {
    onReadyMain() {
      this.mainGridApi = this.mainGridOptions.api;
      this.mainColumnApi = this.mainGridOptions.columnApi;

      this.init();
    },
    createMainColumnDefs() {
      this.columnDefs = [
        {
          headerName:'No',
          field:'no',
          width:80,
          cellStyle:{textAlign: 'center'},
          valueFormatter: function(params) {
            return params.node.rowIndex+1;
          }
        },
        {headerName:'제조사', field:'makerNm', width:300, cellStyle:{textAlign: 'center'}},
        {headerName:'제품군', field:'modelGroupNm', width:300, cellStyle:{textAlign: 'center'}},
        {headerName:'대표모델', field:'standardModelNm', width:350},
        {headerName:'모델명', field:'modelNm', width:350},
        {headerName:'재고수량', field:'goodQty', width:250, cellStyle:{textAlign: 'right'}},
      ];
    },
    goOpen() {
      let that = this
      this.$store.commit('loading')

      const vForm = {
        companyId : this.form.companyId,
        maker : this.form.maker,                // 제조사
        modelGroup : (this.form.subModelGroup.length <= 0 || this.form.subModelGroup === '')  ? this.form.modelGroup : this.form.subModelGroup,          // 제품군
        subModelGroup: this.form.subModelGroup,                 // 제품군 상세
        standardModelNm : this.form.standardModelNm,          //대표모델
        modelNm : this.form.modelNm,                          //모델명
        catId : this.form.catId,
        sortType : this.form.sortType,
        page : this.form.page,
        totalPage : this.form.totalPage,
        curPage : this.form.curPage,
        totalCount : this.form.totalCount,
        processTime : this.form.processTime
      }

      this.$http.post(_url("/api/workMng/productStock/list"), vForm)
          .then(response => {
            this.data = response.data
          })
          .finally(() => {
            this.$store.commit('finish')
          });
    },
    async init() {
      this.$store.commit('loading');
      await this.$http.post(`/api/workMng/productStock/init`)
          .then(response => {
            this.combos['maker'] = response.data.maker;          //제조사
            this.combos['modelGroup'] = response.data.modelGroup;  //제품군
          }).finally(() => {
            //this.goOpen();
            this.$store.commit('finish');
          });

      this.createMainColumnDefs();
    },
    onModelGroupChange(param){
      this.form.subModelGroup = '';
      if(param === '') this.changeModelGroupShow =  false;
      else{
        this.changeModelGroupShow =  true
        // 제품군
        this.$http.get(`/api/codeMng/detail`, { params: {parentId: 143} })  // 제품군
            .then(response => {
              let subData = response.data.filter(x => x.catKey === param);
              this.$http.get(`/api/codeMng/combo`, { params: {parentId: subData[0].catId} })
                  .then(response => {
                    this.combos['subModelGroup'] = response.data || []
                  });
            });
      }
    },
  },
  created() {
    this.statusBar = {
      statusPanels: [
        { statusPanel: 'agTotalRowCountComponent', align: 'right' },
      ],
    };
  },
  mounted() {
    this.form.companyId = this.$store.state.loginInfo.compCd;
  },
  computed: {
    routeName() {
      return this.$route.name
    }
  },
}
</script>

<style lang="scss" scoped>
.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}
</style>